import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Google } from "@/components/icons/google"
import { Microsoft } from "@/components/icons/microsoft"
import { OAUTH_PROVIDERS, OAUTH_PROVIDER_LABELS, type OAuthProvider } from "@/lib/oauth-providers"

const PROVIDER_ICONS: Record<OAuthProvider, typeof Google> = {
  google: Google,
  azure: Microsoft,
}

interface OAuthProviderButtonsProps {
  onProviderClick?: (provider: OAuthProvider) => void
  loading?: boolean
  lastUsedMethod?: string | null
  actionLabel: string
}

export function OAuthProviderButtons({ onProviderClick, loading = false, lastUsedMethod, actionLabel }: OAuthProviderButtonsProps) {
  return (
    <div className="grid gap-3">
      {OAUTH_PROVIDERS.map((provider) => {
        const Icon = PROVIDER_ICONS[provider]
        const lastUsed = lastUsedMethod === provider
        return (
          <div key={provider} className={cn("relative rounded-md", lastUsed && "ring-2 ring-primary ring-offset-2")}>
            {lastUsed && (
              <span className="absolute -top-2 left-3 bg-background px-1.5 text-xs text-muted-foreground z-10">
                Last used
              </span>
            )}
            <Button
              variant="outline"
              className="w-full"
              type="button"
              onClick={() => onProviderClick?.(provider)}
              disabled={loading}
            >
              <Icon className="h-4 w-4" />
              {actionLabel} with {OAUTH_PROVIDER_LABELS[provider]}
            </Button>
          </div>
        )
      })}
    </div>
  )
}
